import styled, { css } from 'styled-components';

export const Button = styled.button`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 18px;
    background: linear-gradient(
      90deg,
      ${theme.v3.colors.brand.snappyOrange[60]},
      ${theme.v3.colors.accent.pink[60]}
    );
    border: none;
    border-radius: ${theme.v3.border.radius.lg};
    color: ${theme.v3.colors.neutral[100]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    cursor: pointer;
    white-space: nowrap;
    align-self: flex-start;

    &:hover {
      opacity: 0.9;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;
